module.exports = __webpack_public_path__ + "media/images/home/costs@2x-819ced4d61e4c892055f0e9cb2a7aba2.png";